import { render, staticRenderFns } from "./collectionDetails.vue?vue&type=template&id=bd1c9b60&scoped=true"
import script from "./collectionDetails.vue?vue&type=script&lang=js"
export * from "./collectionDetails.vue?vue&type=script&lang=js"
import style0 from "./collectionDetails.vue?vue&type=style&index=0&id=bd1c9b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1c9b60",
  null
  
)

export default component.exports